<div *ngIf="fieldConfigs && fieldConfigs.length > 0" class="no-padding w-100">
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row" *ngIf="fieldConfigs">
      <div class="col-6" *ngFor="let field of fieldConfigs">
        <mat-form-field *ngIf="field.type === 'string' || field.type === null" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <input matInput [formControlName]="field.external_name" type="text" />
        </mat-form-field>
        <mat-form-field *ngIf="field.type === 'number'" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <input matInput [formControlName]="field.external_name" type="number" />
        </mat-form-field>
        <mat-form-field *ngIf="field.type === 'enumerator'" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <mat-select [formControlName]="field.external_name">
            <mat-option *ngFor="let option of field.enum_values" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="pb-4">
      <mat-divider *ngIf="attributeConfigs && attributeConfigs.length > 0"></mat-divider>
    </div>

    <div class="row" *ngIf="attributeConfigs">
      <div class="col-6" *ngFor="let field of attributeConfigs">
        <mat-form-field *ngIf="field.type === 'string' || field.type === null" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <input matInput [formControlName]="field.external_name" type="text" />
        </mat-form-field>
        <mat-form-field *ngIf="field.type === 'number'" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <input matInput [formControlName]="field.external_name" type="number" />
        </mat-form-field>
        <mat-form-field *ngIf="field.type === 'enumerator'" appearance="fill">
          <mat-label>{{ formatLabel(field.external_name) }}</mat-label>
          <mat-select [formControlName]="field.external_name">
            <mat-option *ngFor="let option of field.enum_values" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
